__turbopack_context__.v({
  "accessRequestSpinner": "accessRequestStatuses-module-scss-module__6IPojG__accessRequestSpinner",
  "accessRequestStatuses": "accessRequestStatuses-module-scss-module__6IPojG__accessRequestStatuses",
  "denied": "accessRequestStatuses-module-scss-module__6IPojG__denied",
  "follow": "accessRequestStatuses-module-scss-module__6IPojG__follow",
  "followButton": "accessRequestStatuses-module-scss-module__6IPojG__followButton",
  "followSpinner": "accessRequestStatuses-module-scss-module__6IPojG__followSpinner",
  "pending": "accessRequestStatuses-module-scss-module__6IPojG__pending",
  "requestAccessButton": "accessRequestStatuses-module-scss-module__6IPojG__requestAccessButton",
  "requestStatus": "accessRequestStatuses-module-scss-module__6IPojG__requestStatus",
  "spinner": "accessRequestStatuses-module-scss-module__6IPojG__spinner",
});
